import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { SessionProvider } from './session'
import { LanguageProvider } from './i18n'
import { router } from './router'
import { applyStoredTheme } from '@weapps/design'
import './styles.css'

// The Accounts App follows the shared Cross-App Preference (ADR 0098): the theme override from the
// `.polux` cookie, else the OS. Apply now and track live OS changes while the pref is `system`.
applyStoredTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <SessionProvider>
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  </SessionProvider>,
)
